import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow as MuiTableRow,
} from "@mui/material";

import { MUIStyled } from "../../shared/MUIStyled";
import SABox from "../../shared/SABox";
import SAStatusBadge from "../../shared/SAStatusBadge";
import SATypography from "../../shared/SATypography";
import SATarget from "../../shared/table-components/SATarget";

const TableContainerStyled = MUIStyled(TableContainer)({
  boxShadow: "none",
  maxHeight: 210,
  width: "100%",
  background: "#fff",
  "&.MuiPaper-root": {
    margin: 0,
  },
});
const TableCellHeadStyled = MUIStyled(TableCell)({
  fontWeight: 700,
  background: "#f9fafb",
  color: "#111827",
  borderBottom: "1px solid #eee",
  fontSize: 15,
  padding: 8,
});
const TableCellBodyStyled = MUIStyled(TableCell)({
  color: "#111827",
  fontWeight: 500,
  fontSize: 13,
  padding: 8,
});

const columns = [
  { key: "material_item", label: "material-item" },
  { key: "material_type", label: "material-type" },
  { key: "carat_type", label: "carat-type" },
  { key: "weight", label: "weight-carat-weight" },
  { key: "quantity", label: "quantity" },
  { key: "shape_cut", label: "cut-shape" },
];

export default function ProductMaterialsTable({ product, t }) {
  const materials = product?.product_materials || product || [];
  return (
    <SABox sx={{ backgroundColor: "#fff" }}>
      <TableContainerStyled
        component={Paper}
        sx={{
          overflowY: materials.length > 5 ? "auto" : "unset",
          width: "100%",
        }}
      >
        <Table
          size="small"
          sx={{
            width: "100%",
            border: "1px solid #e5e7eb",
            boxShadow: "none",
            background: "#fff",
          }}
          stickyHeader
        >
          <TableHead>
            <MuiTableRow>
              {columns.map((col) => (
                <TableCellHeadStyled key={col.key}>
                  {t(col.label)}
                </TableCellHeadStyled>
              ))}
            </MuiTableRow>
          </TableHead>
          <TableBody>
            {materials.length === 0 ? (
              <MuiTableRow>
                <TableCellBodyStyled colSpan={columns.length} align="center">
                  <SATypography sx={{ color: "#6B7280", py: 1 }}>
                    {t("no-data-found")}
                  </SATypography>
                </TableCellBodyStyled>
              </MuiTableRow>
            ) : (
              materials.map((mat) => (
                <MuiTableRow key={mat.id}>
                  <TableCellBodyStyled>
                    {mat.material_item || "-"}
                  </TableCellBodyStyled>
                  <TableCellBodyStyled>
                    <SAStatusBadge status={mat.material_type?.toUpperCase()} />
                  </TableCellBodyStyled>
                  <TableCellBodyStyled>
                    {mat.carat_type || "-"}
                  </TableCellBodyStyled>
                  <TableCellBodyStyled>
                    <SATarget value={mat.weight || "-"} />
                  </TableCellBodyStyled>
                  <TableCellBodyStyled>
                    {mat.quantity || "-"}
                  </TableCellBodyStyled>
                  <TableCellBodyStyled>
                    {mat.shape_cut || "-"}
                  </TableCellBodyStyled>
                </MuiTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainerStyled>
    </SABox>
  );
}
